export const styleSheet = {

  bgDark: '#2c2c2c',

  colorMain: '#335B91', // #6B8FEA
  colorMainDark: '#334391', //#375B92
  defaultFontColor: '#3c3c3c',
  shape: '#FFF',
  shapeMedium: '#b5b5b5',

  shapeDark: '#6C6C6C',
  darkerGrey: '#5c5c5c',

  titleLight: '#F4A034',

  cancel: '#f03a3a',

  success: '#3CB371',
  info: '#1C86EE',
  warning: '#EEB422',
  error: '#EE9A49',

  mainFont: 'Quicksand'

}